import React from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import { translate } from 'react-i18next';

import { patchTo } from 'widgets/I18nLink';
import { getKey } from 'utils';

import './RelatedCitiesSection.css';

const RelatedCitiesSection = ({
  t,
  related
}) => (
  <div className="section city-related-section">
    <Grid>
      <h2>{t('Nearby destinations')}</h2>

      <ul className="city-related-list">
        {related.map((item) => (
          <li
            key={item.id}
            className="city-related-item"
          >
            <a
              className="btn city-related-link"
              href={patchTo(`/${item.url}/`)}
            >
              {t(`${getKey(item.bikeType, 'nameEn')} rental`)}
              {' '}
              {getKey(item.searchCity, 'name')}
            </a>
          </li>
        ))}
      </ul>
    </Grid>
  </div>
);

export default translate(['translation'])(RelatedCitiesSection);



// WEBPACK FOOTER //
// ./src/components/StaticCityPage/RelatedCitiesSection/RelatedCitiesSection.js